<template>
  <loading :loading="isLoading" message="Removing contact">
    <error :error="error"/>
    <b-table :items="mutableContacts" :fields="fields">
      <template #cell(contact_type)="data">
        <div :style="`font-weight:${data.value === 'External' ? 'bold' : 'normal'}`">{{ data.value.replace(/_/g, ' ') }}</div>
      </template>
      <template #cell(email)="data">
        <a :href="`mailto:${data.value}?Subject=PanEssex+Enquiry`">{{ data.value }}</a>
      </template>
      <template #cell(telephone)="data">
        <a :href="`tel:${data.value}`">{{ data.value }}</a>
      </template>
      <template #head(id)>Actions</template>
      <template #cell(id)="data">
        <b-button variant="danger" @click="removeContact(data.value)">Remove</b-button>
      </template>
    </b-table>
  </loading>
</template>

<script>
import { mapGetters } from 'vuex'
import Error from './Error.vue'
import Loading from './Loading.vue'

export default {
  components: { Error, Loading },
  props: ['contacts', 'short', 'showactions'],
  data() {
    const d = {
      mutableContacts: this.contacts,
      isLoading: false,
      error: null,
      fields: this.short
        ? ['name', 'email', 'telephone']
        : ['authority', 'contact_type', 'name', 'email', 'telephone'],
    };
    if (this.showactions) {
      d.fields = [ ...d.fields, 'id' ];
    }
    return d;
  },
   computed: {
    ...mapGetters([
      'oidcUser',
    ]),
    authority() {
      return this.$authority(this.oidcUser);
    },
  },
  watch: {
    contacts: {
      immediate: true,
      handler(val) {
        this.mutableContacts = val;
      },
    },
  },
  methods: {
    removeContact(id) {
      this.error = null;
      this.isLoading = true;
      const { access_token } = this.$store.state.oidcStore;
      this.$reportingApi.runAction('panessex', access_token, {
        actionName: 'RemoveContact',
        // this is not a security risk as the authotity is used on the other side to prevent deleting others on purpose
        parameters: { id }, 
      })
      .then(() => {
        // remove item manually
        this.mutableContacts = this.mutableContacts.filter(c => c.id !== id);
        this.$store.dispatch('invalidateCache', `contacts_for_${this.authority}`);
        this.isLoading = false;
      })
      .catch(e => { this.error = e.message; this.isLoading = false; });
    },
  },
};
</script>
